import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HelpMenuComponent } from './help-menu.component';
import { SharedModalsModule } from '../modals/shared-modals.module';

@NgModule({
  declarations: [HelpMenuComponent],
  imports: [
    CommonModule,
    SharedModalsModule
  ],
  exports: [HelpMenuComponent]
})
export class HelpMenuModule {}
